import { Grid, Typography } from "@material-ui/core";
import React from "react";
import "./Home.css";
import Typewriter from "typewriter-effect";
import { useHistory } from "react-router-dom";

function Home() {
  const history = useHistory();

  return (
    <div className="home">
      <nav className="navbar">
        {/* <div className="nav-max-width"> */}
        <Typography className="text">
          paok<span>ue.</span>
        </Typography>
        <div className="menu">
          <Typography className="text1" onClick={() => history.push("/")}>
            Home
          </Typography>
          <Typography
            className="text1"
            onClick={() => history.push("/contact")}
          >
            Contact
          </Typography>
          <Typography
            className="text1"
            onClick={() => history.push("/coursehomepage")}
          >
            Courses
          </Typography>
        </div>
        {/* </div> */}
      </nav>
      <hr />
      <div className="max-width">
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={6}>
            <div className="right">
              <img src="./image/profile2.png" alt="profile" />
            </div>
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <div className="left">
              <Typography className="text1">Hello, my name is</Typography>
              <br />
              <Typography className="text2">paokue SAOLONG</Typography>
              <br />
              <Typography className="text3">
                <Typewriter
                  onInit={(Typewriter) => {
                    Typewriter.typeString("I am a Youtuber!.")
                      .pauseFor(2000)
                      .deleteAll()
                      .typeString("I am a Developer!.")
                      .pauseFor(2000)
                      .deleteAll()
                      .typeString("I am a Blogger!.")
                      .pauseFor(2000)
                      .deleteAll()
                      .typeString("I am a Freelancer!.")
                      .pauseFor(2000)
                      .deleteAll()
                      .typeString("I am a Designer!.")
                      .start();
                  }}
                />
              </Typography>
              <br />
              <Typography className="text4">
                knack of building web-application with front and back end
                operations
              </Typography>
              <br />
              <button onClick={() => history.push("/contact")}>Hire me</button>
            </div>
          </Grid>
        </Grid>
      </div>
      <hr />
    </div>
  );
}

export default Home;
